export const prefixer = (prefix: string) => (key: string) => `${prefix}.${key}`;
